export default __webpack_public_path__ + "static/media/UOG-Logo-2-row-trim.3fcf6f06.png";